const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Icon list", "uipress-lite"),
  moduleName: "uip-icon-list-block",
  description: __("Creates a list with icons", "uipress-lite"),
  group: "elements",
  icon: "list",
};
